import React from "react";
import App from "./App";
import Routes from "./Routes";

const AudacesProtocol = () => {
  return (
    <App>
      <Routes />
    </App>
  );
};

export default AudacesProtocol;
